import { render } from "./PimProductsOverviewItemIcons.vue?vue&type=template&id=5e8ff2c2&ts=true"
import script from "./PimProductsOverviewItemIcons.vue?vue&type=script&lang=ts"
export * from "./PimProductsOverviewItemIcons.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__